// YT Links

export const ytLinks = {
  "how-it-works": "https://www.youtube.com/embed/xIEMyn0yoq0?si=a-jbifWucyUHJTkw",
  "homepage": "https://www.youtube.com/embed/JJeBPGOC2F8?si=PGp_PCAo4XvjXlOD",
  "login": "https://www.youtube.com/embed/l0Vi-aj78YQ?si=eT3DPOK6GHF05zHe"
};